import * as Store from '../store'
import LoginActionTypes from '../GlobalModules/Login/Utility/LoginActionTypes';
import axios from 'axios';
import LoginUtility from '../GlobalModules/Login/Utility/LoginUtility'
import Utility from './Utility'
import { createHashHistory } from 'history';
import moment from 'moment';
import AllActionTypes from './AllActionTypes';
import { setUserCredentials, setToken } from '../GlobalModules/Login/Actions/LoginAction';

export const get = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${process.env.BASE_URL}${url}`;
		var params = data ? data.filters : {};
		let invokeError = true;
		if (typeof params == "string") {
			params = JSON.parse(params)
			if (params.size_width && params.size_height) invokeError = false;
		}
		axios.get(apiBaseUrl, {
			params: data,
			headers: getHeaders(header, url)
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			const excludeError = ['api/customer/pgate/check'];
			if (invokeError && !excludeError.includes(url)) {
				errorHandlingBlock(error)
			}
		})
	});
}
export const post = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${process.env.BASE_URL}${url}`;
		axios.post(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}
export const patch = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${process.env.BASE_URL}${url}`;
		axios.patch(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}
export const put = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${process.env.BASE_URL}${url}`;
		axios.put(apiBaseUrl, data, { headers: getHeaders(header, url) }).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}
export const del = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${process.env.BASE_URL}${url}`;
		axios.delete(apiBaseUrl, {
			data: data,
			headers: getHeaders(header, url)
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}

export const download = (url, data, header = "global") => {
	return new Promise((resolve, reject) => {
		let apiBaseUrl = `${process.env.BASE_URL}${url}`;
		axios.get(apiBaseUrl, {
			params: data,
			headers: getHeaders(header, url),
			responseType: 'arraybuffer'
		}).then((response) => {
			resolve(response);
		}).catch((error) => {
			reject(error);
			errorHandlingBlock(error)
		})
	});
}



export const getHeaders = (header, path = "") => {
	checkExpiryOfToken()
	let headers = process.env.BASE_URL.includes('ngrok')
		? { 'ngrok-skip-browser-warning': 'true' }
		: {};
	headers['language'] = localStorage.getItem('i18nextLng');
	headers['api_key'] = localStorage.getItem('api_key') || '';
	// if (path !== `${process.env.EXTENDED_URL}login`) {
	// 	headers['business_details'] = '';
	// }
	if (header == null) {
		headers['language'] = localStorage.getItem('i18nextLng');
	} else if (header == "global") {
		if (path == `${process.env.EXTENDED_URL}users/mfa/verify`) {
			headers["Session"] = Store.default.getState().LoginReducer.session
		} else if (path == `${process.env.EXTENDED_URL}users/otp/verify`) {
			headers["Session"] = Store.default.getState().LoginReducer.session
		} else if (path == `${process.env.EXTENDED_URL}users/usr_mfa_assign`) {

		} else if (path == `${process.env.EXTENDED_URL}users/associate_software_token`) {
			headers["AccessToken"] = Store.default.getState().LoginReducer.accessToken;
		} else if (path == `${process.env.EXTENDED_URL}users/verify_software_token`) {
			headers["AccessToken"] = Store.default.getState().LoginReducer.accessToken;
		} else {
			if (path != `${process.env.EXTENDED_URL}users/login`) {
				headers["Authorization"] = Store.default.getState().LoginReducer.token;
			}
		}
	} else if (Object.keys(header).length > 0) {
		if (path == `${process.env.EXTENDED_URL}users/userforcepasswordchange`) {
			Object.keys(header).map((key, idx) => {
				headers[key] = header[key];
			})
		} else if (path == `${process.env.EXTENDED_URL}users/signout`) {
			localStorage.setItem('i18nextLng', 'en');
			headers["Authorization"] = Store.default.getState().LoginReducer.token;
			headers["Accesstoken"] = Store.default.getState().LoginReducer.accessToken;
		} else if (path == `${process.env.EXTENDED_URL}users/changepassword`) {
			headers["Authorization"] = Store.default.getState().LoginReducer.token;
			headers["Accesstoken"] = Store.default.getState().LoginReducer.accessToken;
		}
	}
	return headers
};

export const checkExpiryOfToken = () => {
	let currentDateTime = new Date();
	const expiryTime = new Date(Store.default.getState().LoginReducer.expiresIn.expiryTime)
	const loggedInTime = new Date(Store.default.getState().LoginReducer.expiresIn.loggedInTime)
	const expiryInterval = Store.default.getState().LoginReducer.expiresIn.expiryInterval
	if (expiryTime != "") {
		let deltaDifference = ((currentDateTime == "" ? 0 : currentDateTime) - (loggedInTime == "" ? 0 : loggedInTime)) / 1000
		if (currentDateTime >= expiryTime && (deltaDifference <= expiryInterval)) {
			refershToken();
		}
	}
};

export const refershToken = () => {
	const history = createHashHistory();
	let res = new Promise((resolve, reject) => {
		let header = {};
		header["Authorization"] = Store.default.getState().LoginReducer.token;
		header["refreshToken"] = Store.default.getState().LoginReducer.refreshToken;
		let apiBaseUrl = `${process.env.BASE_URL}${process.env.EXTENDED_URL}users/refreshtoken`;
		let data = {}
		// data["refreshToken"] = Store.default.getState().LoginReducer.refreshToken;
		axios.patch(apiBaseUrl, data, { headers: header }).then((response) => {
			resolve(response);
		}).catch((error) => {
			logoutApp()
		})
	});
	res.then((result) => {
		let finalResponse = result.data
		if (finalResponse.success) {
			const finalIdToken = finalResponse.data.tokenType + ' ' + finalResponse.data.idToken;
			const accessToken = finalResponse.data.accessToken
			const expiresIn = LoginUtility.getExpiryDetails(finalResponse.data.expiresIn)

			Store.default.dispatch({
				type: LoginActionTypes.SET_TOKEN,
				payload: finalIdToken
			});
			Store.default.dispatch({
				type: LoginActionTypes.SET_ACCESS_TOKEN,
				payload: accessToken
			});
			Store.default.dispatch({
				type: LoginActionTypes.SET_TOKEN_EXPIRE_TIME,
				payload: expiresIn
			});

		} else {
			Utility.toastNotifications("Oops session has been expired!!!", "Error", "error")
			logoutApp()
		}
	})
}


export const logoutApp = async () => {
	localStorage.setItem('i18nextLng', 'en');
	const history = createHashHistory();
	try {
		const header = {
			"Authorization": Store.default.getState().LoginReducer.token,
			"Accesstoken": Store.default.getState().LoginReducer.accessToken
		};

		const apiBaseUrl = `${process.env.BASE_URL}${process.env.EXTENDED_URL}users/signout`;

		await axios.delete(apiBaseUrl, {
			data: {},
			headers: header
		});

		Store.default.dispatch({
			type: LoginActionTypes.LOGOUT,
			payload: { "token": "", "accessToken": "", "refreshToken": "", "expiresIn": { "loggedInTime": "", "expiryTime": "", "expiryInterval": "" }, "userCredentials": {}, version: [], "roleWisePermission": {}, "session": "" }
		});

		Store.default.dispatch({
			type: AllActionTypes.CLEAR_DATA,
			payload: { "loaderState": false, "leftbar": false, "activeLink": { 'accName': "", 'activeClass': "" }, "roleWisePermission": {} }
		});
		history.push(`/${localStorage.getItem('i18nextLng')}/home`);
	} catch (error) {
		console.error(error);
	}
};

export const errorHandlingBlock = (error) => {
	if (error.response) {
		if (error.response.status == 409) {
			// console.log(error.response.data)
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error");
			} else {
				if (error.response.data.message.indexOf("Looks like you already have an account. Try logging in, or reset your password if you do not remember it.") !== -1) {
					Utility.toastNotifications(error.response.data.message, "Info", "info", 10000);
				} else if (error.response.data.message.indexOf("You have already registered but not confirmed your email. We have sent you a new confirmation code.") !== -1) {
					Utility.toastNotifications(error.response.data.message, "Warning", "warning", 10000);
				} else {
					if (error.response.data.message != "Your account is not confirmed yet") {
						Utility.toastNotifications(error.response.data.message, "Error", "error", 10000)
					}
				}
			}
		}
		if (error.response.status == 406) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error", 10000);
			} else {
				Utility.toastNotifications(error.response.data.message, "Error", "error", 10000)
			}
		}
		if (error.response.status == 400) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error", 10000);
			} else {
				if (error.response.data.message.indexOf("Invalid code or auth state for the user.") !== -1) {
					Utility.toastNotifications('Invalid code', "Error", "error");
				} else if (error.response.data.message.indexOf("You have already registered but not confirmed your email. We have sent you a new confirmation code in your email.") !== -1) {
					Utility.toastNotifications(error.response.data.message, "Warning", "warning", 10000);
				} else if (error.response.data.message.indexOf("Your account hasn't been verified yet. A verification code has already been sent to your email. Please use it to verify your account before attempting to reset your password.") !== -1) {
					Utility.toastNotifications(error.response.data.message, "Warning", "warning", 10000);
				} else {
					Utility.toastNotifications(error.response.data.message, "Error", "error", 10000)
				}
			}
		}

		if (error.response.status == 404) {
			if (Array.isArray(error.response.data)) {
				Utility.toastNotifications(error.response.data[0].message, "Error", "error", 10000);
			} else {
				Utility.toastNotifications(error.response.data.message, "Error", "error", 10000)
			}
		}
		if (error.response.status == 401) {
			logoutApp()
			Store.default.dispatch(setToken("", "", "", "")).then(() => {
				Store.default.dispatch(setUserCredentials({}))
			})
			if (error.response.data.message == "The incoming token has expired") {
				Utility.toastNotifications("Oops session has been expired!!!", "Error", "error")
			}
		} else if (error.response.data) {
			if (error.response.data.message != "Your account is not confirmed yet") {
				if (!['You have already registered but not confirmed your email. We have sent you a new confirmation code in your email.', "Your account hasn't been verified yet. A verification code has already been sent to your email. Please use it to verify your account before attempting to reset your password.", "Looks like you already have an account. Try logging in, or reset your password if you do not remember it.", 'You have already registered but not confirmed your email. We have sent you a new confirmation code.'].includes(error.response.data.message)) {
					Utility.toastNotifications(error.response.data.message, "Error", "error", 10000)
				}
			}
		}
	} else {
		Utility.toastNotifications(error.message, "Error", "error", 10000)
	}
}
// export const setToken = (value) => {
// 	Store.default.dispatch({
// 		type: LoginActionTypes.SET_TOKEN,
// 		payload: value
// 	})
// };
